<!-- 人才列表 -->
<template>
  <div class="talents_list">
    <!-- 搜索框 -->
    <header class="inp">
      <Button type="warning" size="large" style="width:130px" @click="search()">搜索</Button>
      <Input v-model="obj.name" @on-enter="search()" size="large" prefix="ios-search" placeholder="输入关键词，搜索相关人才">
      </Input>
    </header>

    <div class="search_text">
      <div class="label">猜你想搜:</div>
      <div>
        <Tag style="cursor: pointer;" v-for="(item,index) in Position" :checked="Position_Tag == item.text" :key="index" checkable color="warning" @on-change="(val)=>PositionTag(val,item)">{{item.text}}</Tag>
        <br>

      </div>
    </div>

    <div class="talents_number">
      <img src="@/assets/images/rencai_flag.png" alt="">
      <p>您已查看了&nbsp;<span>{{talents_number}}</span>&nbsp;个人才</p>
    </div>

    <div class="condition">
      <div class="condition_in" style="margin-bottom:30px">
        <p style="width:90px">区域</p>
        <Cascader :data="workArea_data" trigger="hover" style="width: 200px;" @on-change='new_street_change'></Cascader>
      </div>

      <div class="condition_in" style="margin-bottom:30px">
        <p style="width:90px">性别</p>
        <Tag style="cursor: pointer;" v-for="(item,index) in sex" :checked="sex_Tag == item.name" :key="index" checkable color="warning" @on-change="sexTag(item)">{{item.name}}</Tag>
      </div>

      <div class="condition_in">
        <p style="width:90px">学历要求</p>
        <Tag style="cursor: pointer;" v-for="(item,index) in education" :checked="education_Tag == item.name" :key="index" checkable color="warning" @on-change="educationTag(item)">{{item.name}}</Tag>
      </div>
    </div>

    <div class="list">
      <Spin size="large" fix v-if="spinShow"></Spin>
      <ul v-if="list.length">
        <li v-for="(item,index) in list" :key="index">
          <Row>
            <Col span="2" style="text-align:center">
            <!-- <img :src="require(`@/assets/images/${Icon(item.sex)}`)" alt=""> -->
            <img :src="item.icon" alt="">
            </Col>
            <Col span="20">
            <p style="color:#000;">
              <span>{{item.name[0]}}{{item.sex == 1?'先生':'小姐'}}</span>
              <Tag color="green" v-if="item.readingStatus && item.readType == 1">已查看</Tag>&nbsp;
              <Tag color="blue" v-if="item.readingStatus && item.readType == 2">已投递</Tag>&nbsp;
            </p>
            <p style="margin:15px 0;color:#000;">
              <span>{{jsGetAge(item.birthDate)}}岁丨</span>
              <!-- <span>{{working_age(item.workedDate)}}年工作经验丨</span> -->
              <span>{{item.education}}</span>

            </p>
            <p>
              <span style="color:#a7a7a7">
                期望：

                {{item.workArea?item.workArea.toString()+'|':''}}
                <span v-if="obj.category !== 'parttime'">
                  {{item.fullTime.month_income?item.fullTime.month_income:''}}
                </span>
                <span v-else>
                  {{item.fullTime.hour_income?item.fullTime.hour_income:''}}
                </span>

                <!-- {{item.fullTime.hour_income?item.fullTime.hour_income+' | ':''}}
                {{item.fullTime?item.fullTime.daily_income+' | ':''}} -->

              </span>
            </p>
            </Col>
            <Col span="2">
            <router-link :to="{name:'talents_details',query:{id:item.userId}}">
              <Button style="min-width:80px" type="warning" long>前去查看</Button>
            </router-link>

            </Col>
          </Row>

        </li>
      </ul>
      <div v-else style="text-align:center;padding:30px 0">
        暂无人才
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      spinShow: false,
      obj: {
        name: "",
        district: "",
        sex: "",
        education: "",
        category: "",
        certificates: "",
        enterpriseId: localStorage.getItem('firm_enterpriseId'),
        page: 1,
        size: 10
      },

      Position_Tag: "",
      Position: [{
        id: 1,
        type: 'newResume',
        text: '最新简历'
      },
      {
        id: 2,
        type: 'civilian',
        text: '人事招聘'
      },
      {
        id: 3,
        type: 'mechanic',
        text: '财税'
      },
      {
        id: 4,
        type: 'market',
        text: '市场营销'
      },
      {
        id: 5,
        type: 'otherCivil',
        text: '其他文职'
      },
      {
        id: 6,
        type: 'parttime',
        text: '临时/小时工'
      },
      {
        id: 7,
        type: 'factory',
        text: '手工计件'
      },
      {
        id: 8,
        type: 'homekeeping',
        text: '家政服务'
      },
      {
        id: 9,
        type: 'Other',
        text: '其他'
      }
      ],
      talents_number: "",
      workArea_data: [],


      //性别要求
      sex_Tag: "不限",
      sex: [
        {
          name: '不限',
          id: ''
        },
        {
          name: '男',
          id: '1'
        },
        {
          name: '女',
          id: '2'
        },
      ],

      //学历要求
      education: [],
      education_Tag: "学历不限",

      list: []
    }
  },
  methods: {
    //选项改变重置page
    search() {
      this.obj.page = 1
      this.get_data()
    },
    //类别1选择后
    PositionTag(val, item) {
      if (val) {
        this.Position_Tag = item.text
        this.obj.category = item.type
      } else {
        this.obj.category = ''
      }
      this.search()
    },
    //地区
    new_street_change(val) {
      this.obj.district = val.join('-')
      this.search()
    },
    //性别
    sexTag(item) {
      this.sex_Tag = item.name
      this.obj.sex = item.id
      this.search()
    },
    //学历
    educationTag(item) {
      this.education_Tag = item.name
      this.obj.education = item.name
      this.search()
    },
    //封装区域数据递归
    recursion(arr) {
      arr.forEach((item, index) => {
        item.value = item.name
        item.label = item.name
        if (item.subareas) {
          item.children = item.subareas
          this.recursion(item.children)
        }
      })
    },
    //封装获取数据
    get_data() {
      this.spinShow = true
      this.app("enterpriseOperators", "selectRecommendationLetter", this.obj).then(res => {
        this.spinShow = false
        console.log("人才列表:", res);
        this.list = res.result

        this.list.forEach((item, index) => {
          //生成随机头像
          if (item.sex == 1) {
            let num = Math.ceil(Math.random() * 1000000000 % 9);
            if (num == 1 || num == 2 || num == 3) {
              item.icon = require(`@/assets/images/man_1.png`)
            } else if (num == 4 || num == 5 || num == 6) {
              item.icon = require(`@/assets/images/man_2.png`)
            } else {
              item.icon = require(`@/assets/images/man_3.png`)
            }
          } else {
            let num = Math.ceil(Math.random() * 1000000000 % 9);
            if (num == 1 || num == 2 || num == 3) {
              item.icon = require(`@/assets/images/women_1.png`)
            } else if (num == 4 || num == 5 || num == 6) {
              item.icon = require(`@/assets/images/women_2.png`)
            } else {
              item.icon = require(`@/assets/images/women_3.png`)
            }
          }

        })
      })
    },
    //封装获取已查看人才数
    get_talents_number() {
      this.app('enterpriseOperators', 'talentedPeopleList', {
        enterpriseId: localStorage.getItem("firm_enterpriseId"),
        isCount: true
      }).then(res => {
        this.talents_number = res.data
      })
    },

  },
  created() {
    this.get_data()
    this.get_talents_number()
    //获取后端区域数组
    this.app("enterpriseOperators", "getAreas", {}).then(res => {
      this.recursion(res.data)
      this.workArea_data = res.data
    })

    //获取学历学历要求列表
    this.app("enterpriseOperators", "getDataList", {
      type: "education"
    }).then(res => {
      this.education = res.result
    })
  }
}
</script>

<style lang="less" scoped>
@import "./talents_list.less";
</style>
